export default __webpack_public_path__ + "static/media/washupReferral.73d9d55b.png";